import { createContext, FC } from 'react'
import { useAuth } from '../../auth/auth.hook'

export const ReservationIdContext = createContext('')

export const ReservationIdProvider: FC = ({ children }) => {
  const { auth } = useAuth()

  if (auth.loading) {
    return null
  }

  if (!auth.isAuthenticated) {
    return null
  }

  const reservationId = (auth as any).reservationId

  return <ReservationIdContext.Provider value={reservationId}>{children}</ReservationIdContext.Provider>
}
